var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "record-appraisal-detail loading-content-container" },
    [
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "loading-overlay d-flex justify-content-center pt-5",
            },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "b-row",
            [
              _c(
                "csp-desktop-info-card",
                {
                  attrs: {
                    cols: 12,
                    "form-context": _vm.appraisalFormContext,
                    icon: "inticon-autoclaim_billing",
                    title: `Forderung TÜV SÜD #${_vm.appraisalFormContext.data.appraisalNumber}`,
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-6",
                        attrs: {
                          "form-context": _vm.appraisalFormContext,
                          label: "Gutachtennummer",
                          property: "appraisalNumber",
                          type: "text",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-6",
                        attrs: {
                          "form-context": _vm.appraisalFormContext,
                          label: "Rechnungsnummer",
                          property: "invoiceNumber",
                          type: "text",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-6",
                        attrs: {
                          "form-context": _vm.appraisalFormContext,
                          label: "Rechnungsdatum",
                          property: "invoiceDate",
                          type: "date",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-6",
                        attrs: {
                          "form-context": _vm.appraisalFormContext,
                          label: "Gutachter",
                          property: "appraiserName",
                          type: "text",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-6",
                        attrs: {
                          "form-context": _vm.appraisalFormContext,
                          label: "E-Mail Gutachter",
                          property: "appraiserEmail",
                          type: "text",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-6",
                        attrs: {
                          "form-context": _vm.appraisalFormContext,
                          label: "Produktgruppe",
                          property: "productGroup",
                          type: "text",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-6",
                        attrs: {
                          "form-context": _vm.appraisalFormContext,
                          label: "Offener Betrag",
                          property: "amountOpen",
                          type: "currency",
                        },
                      }),
                      _vm._v(" "),
                      _c("csp-desktop-info-card-element", {
                        staticClass: "col-6",
                        attrs: {
                          "form-context": _vm.appraisalFormContext,
                          label: "Vorherige Forderungsnummer",
                          property: "previousAppraisalNumber",
                          type: "text",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c("csp-table", {
            ref: "lineItemsTable",
            staticClass: "mt-4",
            attrs: {
              "disable-filters": true,
              icon: "inticon-autoclaim_damage",
              "items-ajax-url": _vm.lineItemsAjaxUrl,
              "rows-selectable": false,
              scrollable: true,
              "table-headline": "Posten",
            },
            on: {
              "fields-loaded": (fields) =>
                (_vm.lineItemColumns = fields.map((f) => f.key)),
            },
            scopedSlots: _vm._u(
              [
                _vm._l(_vm.lineItemColumns, function (col) {
                  return {
                    key: `cell(${col})`,
                    fn: function ({ data }) {
                      return [
                        _c("csp-text-with-tooltip", {
                          key: col,
                          attrs: {
                            delay: _vm.tooltipDelay,
                            text: String(data[col]),
                            tooltip: String(data[col]),
                            truncate: "",
                          },
                        }),
                      ]
                    },
                  }
                }),
                {
                  key: "cell(changelog)",
                  fn: function ({ data }) {
                    return [
                      _c("csp-changelog-modal", {
                        attrs: { "changelog-url": data.changelog.changelogUrl },
                      }),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && _vm.canShowDigitalMailboxEmails
        ? _c(
            "b-row",
            { staticClass: "mt-4" },
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("csp-digital-mailbox-email-list-table", {
                    attrs: {
                      "items-ajax-url": _vm.itemsAjaxUrl,
                      "table-headline": "Zugeordnete E-Mails",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "cell(actions)",
                          fn: function ({ data }) {
                            return [
                              _c("div", { staticClass: "table-actions" }, [
                                data.actions.attachmentCount
                                  ? _c(
                                      "a",
                                      {
                                        attrs: { title: "Anhänge anzeigen" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.openAttachmentModal(
                                              data.actions.emailId
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "inticon-autoclaim_files",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      281697658
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("csp-email-attachment-modal", {
        attrs: {
          "email-id": _vm.attachmentModalEmailId,
          show: _vm.showAttachmentModal,
        },
        on: { hidden: _vm.onAttachmentModalHidden },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }